export default {
  email: "{field} format is wrong",
  required: "{field} is required",
  numeric: "{field} format is wrong",
  unknown: "Something went wrong, please refresh and try again. If the problem persists, please contact us at support@edcity.hk.",
  image: "{field} isn't a recognized image file format.",
  recaptcha: "Please verify that you are not a robot.",
  sameAs: "{field} and {sameAsField} are different",
  maxLength: "Max length of {field} is exceed",
  verifyCode:{
    invalid: "The code is invalid.",
    expired: "The verification code has expired, please go back and try again.",
    notFound:"The corresponding record cannot be found, please go back and try again.",
    emailDuplicate:"This email address is already being used as a login email for another EdCity account. Please go back and try again with a different email address.",
    sixDigit: "{field} must be six digits."

  },
};
